import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Toast } from 'sonata-react-components';
import { MediaTypeEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';

import { PricingAdvanceSettings } from './PricingAdvanceSettings';
import { usePricingModel } from './PricingModel.context';
import { PricingModelStyled } from './PricingModel.styled';
import { PricingModelMainSection } from './PricingModelMainSection';

type Props = {
  id: string;
};

type State = {
  showErrorToast: boolean;
};

function PricingModelView({ id }: Props) {
  const { formatMessage } = useIntl();
  const { errors, mediaType, user } = usePricingModel();
  const [{ showErrorToast }, setState] = useState<State>({ showErrorToast: true });

  return (
    <PricingModelStyled className="pricingModel" id={id}>
      <div className="pricingModel__box" id={id}>
        <header className="pricingModel__boxTitle">
          {formatMessage({
            defaultMessage: 'Pricing model',
            id: 'pricingModel.title'
          })}
        </header>
        <div className="pricingModel__body">
          {Boolean(errors) && showErrorToast && (
            <Toast
              autoClose={false}
              className="pricingModel__errorToast"
              closeToast={() => setState(prevState => ({ ...prevState, showErrorToast: false }))}
              icon="fal fa-exclamation-triangle"
              text={formatMessage({
                defaultMessage: 'Please check all required fields',
                id: 'pricingModel.mainError'
              })}
              type="danger"
            />
          )}
          <div className="pricingModel__configContainer">
            {!(mediaType === MediaTypeEnum.pmp && user.isTradingDesk) && (
              <PricingModelMainSection id={`mainSection-${id}`} />
            )}
            <PricingAdvanceSettings id={`mainSection-${id}`} />
          </div>
        </div>
      </div>
    </PricingModelStyled>
  );
}

export default PricingModelView;
